import { Route } from "react-router-dom";
import { Switch } from "react-router-dom";

import routes from "routes";
import { ResultsUni5TreatmentOptions } from "./ResultsUni5TreatmentOptions";
import { ResultsUni5ClinicalPlans } from "./ResultsUni5ClinicalPlans";
import { ResultsUni5Pricing } from "./ResultsUni5Pricing";
import { ResultsUni5Restored } from "./ResultsUni5Restored";

export const ResultsUni5RestoredRouter: React.FC = () => {
  return (
    <Switch>
      <Route path={routes.treatmentOptionsRestored}>
        <ResultsUni5TreatmentOptions resultsRestored />
      </Route>
      <Route path={routes.plansRestored}>
        <ResultsUni5ClinicalPlans />
      </Route>
      <Route path={routes.pricingRestored}>
        <ResultsUni5Pricing />
      </Route>
      <ResultsUni5Restored />
    </Switch>
  );
};
